import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {RfqDataService} from '../service/rfq.data.service';
import {Message} from 'primeng/api';
import {QuotationControllerService, RfqLookupDto, RfqPropertyDto, RfqRequestDto, SelectOption} from '../../@api';
import {FormGroup, NgForm} from '@angular/forms';
import {Home, ProgressIndicatorService} from '../../@shared';
import {v4 as uuidv4} from 'uuid';
import {environment} from '../../../environments/environment';

const ERROR_SUBMIT = 'Could not submit your request for quotation. Please contact us at info@solarcentral.co.za.';
const ERROR_VALIDATION = 'Please correct errors on the indicated fields.';

@Component({
    selector: 'app-rfq-step-three',
    templateUrl: './step-three.component.html',
    styleUrls: ['../rfq.component.scss', '../rfq.blocks.scss']
})
export class StepThreeComponent implements OnInit {

    @Input('event') event$: EventEmitter<boolean>;
    @Input('navigation$') navigation$: EventEmitter<boolean>;

    @ViewChild('stepThree', {static: false}) stepThreeDivElement!: ElementRef<HTMLDivElement>;
    @ViewChild('navigation') navigation!: ElementRef<HTMLDivElement>;
    @ViewChild('contactComponentForm') contactComponentForm: NgForm;

    formSubmitted: boolean = false;
    errors: Message[] = [{severity: 'error', detail: 'Please correct errors on the indicated fields.'}];
    uuid: string = uuidv4();

    provinces: SelectOption[] = [];

    regions: SelectOption[] = [];

    importanceOptions: any[] = [
        {label: 'Reduce electricity bills', value: 'Reduce electricity bills'},
        {label: 'Quick return on investment', value: 'Quick return on investment'},
        {label: 'Quality', value: 'Quality'},
        {label: 'Low upfront costs', value: 'Low upfront costs'},
        {label: 'Ability to upgrade later', value: 'Ability to upgrade later'},
        {label: 'Overcome power interruptions', value: 'Overcome power interruptions'}
    ];

    contactOptions: any[] = [
        {label: 'Morning', value: 'Morning'},
        {label: 'Afternoon', value: 'Afternoon'},
        {label: 'Evening', value: 'Evening'},
        {label: 'Weekends', value: 'Weekends'},
        {label: 'Anytime', value: 'Anytime'},
    ];

    constructor(@Inject(DOCUMENT) public document: Document,
                public data: RfqDataService,
                private quotationService: QuotationControllerService,
                private progressIndicatorService: ProgressIndicatorService) {
    }

    ngOnInit(): void {
        this.formSubmitted = false;

        this.event$?.subscribe((event: boolean): void => {
            this.data.steps[2].height
                = this.navigation.nativeElement.scrollHeight + this.stepThreeDivElement.nativeElement.scrollHeight;
        });

        this.data.coverage = this.data.coverage || 50;
        this.quotationService.findRfqLookupData().subscribe((response: RfqLookupDto): void => {
            this.data['provinces'] = response.provinces;
            this.data['regions'] = response.regions;

            this.provinces = this.data['provinces'];
            this.regions = this.data['regions'];
        }, error => {
            console.log(error);
        });
    }

    back(): void {
        this.errors = [];
        this.contactComponentForm.form.markAsUntouched();
        this.contactComponentForm.form.markAsPristine();

        this.navigation$.emit(false);
    }

    submit(): void {
        this.formSubmitted = true;
        const form: FormGroup = this.contactComponentForm.form;
        form.markAllAsTouched();

        if (!this.contactComponentForm.form.invalid) {
            this.progressIndicatorService.event$.emit(true);

            let home: Home = this.data['home'];
            let contact: any = this.data['contact'];
            let property: RfqPropertyDto = this.data['property'];

            let total: number = home.usage || 0;
            let totalKw: number = total / 1000;
            let storage: number = home.storage || 0;
            let daytime: number = total - storage;
            let day: number = (total > 0) ? daytime / total * 100 : 0;
            let night: number = 100 - day;
            let dayKwUsage: number = daytime / 1000;
            let nightKwUsage: number = storage / 1000;

            let rfq: RfqRequestDto = {
                id: 0,
                uid: this.uuid,
                profile: environment.access_profile,
                dailyKwUsage: totalKw,
                day: day,
                night: night,
                dayKwUsage: dayKwUsage,
                nightKwUsage: nightKwUsage,
                information: this.data['information'],
                householdSize: this.data['householdSize'],
                provinceId: contact['provinceId'],
                regionId: contact['regionId'],
                fullName: contact['fullName'],
                phone: contact['phone'],
                email: contact['email'],
                contact: contact['contactTime'],
                importance: this.data['importance'],
                coverage: this.data['coverage'],
                property: property
            }

            this.quotationService.newRfqRequest(rfq).subscribe((): void => {
                setTimeout((): void => {
                    this.progressIndicatorService.event$.emit(false);
                    this.navigation$.emit(true);
                }, 3000);
            }, error => {
                console.log(error);
                this.progressIndicatorService.event$.emit(false);
                this.navigation$.emit(false);
            });
        } else {
            console.log('form invalid');
        }
    }

    provinceSelectionChanged($event: any): void {
        let regions: SelectOption[] = this.data['regions'];
        this.regions = regions.filter((f: SelectOption): boolean => f.parent === $event);
    }
}
